import { useState, useRef, useEffect } from "react";
import styles from "./Contact.module.css";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible")),
      { threshold: 0.12 }
    );
    sectionRef.current?.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const copyEmail = async () => {
    await navigator.clipboard.writeText("info@carrcraft.com.au");
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  return (
    <section id="contact" ref={sectionRef} className={styles.section}>
      {/* Background accent */}
      <div className={styles.bgAccent} aria-hidden="true" />

      <div className={styles.inner}>
        <p className={`${styles.eyebrow} reveal`}>// Contact</p>

        <h2 className={`${styles.heading} reveal`}>
          Let's build something{" "}
          <span className={styles.accent}>great.</span>
        </h2>

        <p className={`${styles.sub} reveal`}>
          Have an idea? A problem that needs solving? We'd love to hear from
          you. Drop us a line and let's talk.
        </p>

        <div className={`${styles.emailBlock} reveal`}>
          <a
            href="mailto:info@carrcraft.com.au"
            className={styles.emailLink}
            aria-label="Send email to info@carrcraft.com.au"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            info@carrcraft.com.au
          </a>

          <button
            onClick={copyEmail}
            className={styles.copyBtn}
            aria-label="Copy email address"
          >
            {copied ? (
              <>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                Copied!
              </>
            ) : (
              <>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                </svg>
                Copy address
              </>
            )}
          </button>
        </div>

        {/* Info cards */}
        <div className={`${styles.infoGrid} reveal`}>
          <div className={styles.infoCard}>
            <span className={styles.infoIcon}>📍</span>
            <div>
              <p className={styles.infoLabel}>Based in</p>
              <p className={styles.infoValue}>Australia</p>
            </div>
          </div>
          <div className={styles.infoCard}>
            <span className={styles.infoIcon}>🌏</span>
            <div>
              <p className={styles.infoLabel}>We work with</p>
              <p className={styles.infoValue}>Clients worldwide</p>
            </div>
          </div>
          <div className={styles.infoCard}>
            <span className={styles.infoIcon}>⚡</span>
            <div>
              <p className={styles.infoLabel}>Response time</p>
              <p className={styles.infoValue}>Within 24 hours</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
